import { TranslationContext } from 'contexts/translation-context';

import { useContext } from 'react';
import styled from 'styled-components';
import { BlueLink } from 'components/common/link';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  line-height: 3.5rem;
`;

const SecondText = styled.div`
  font-family: ${props => props.theme.fonts.montserratLight};
  color: ${props => props.theme.colors.siteBlack};
  font-size: 16px;
  @media (max-width: 999px) {
    font-size: 14px;
  }
  text-align: center;
  white-space: break-spaces;
`;
const StyledLink = styled(BlueLink)`
  font-family: ${props => props.theme.fonts.montserratLight};
  font-size: 17px;
  @media (max-width: 999px) {
    font-size: 14px;
  }
`;

export const AcountExistsInCompanyErrorModal = () => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  return (
    <Container>
      <SecondText>{TRANSLATION_TEXT.an_account_already_exists_for_your_company}</SecondText>
      <SecondText>{TRANSLATION_TEXT.administrator_will_follow_up}</SecondText>
      <SecondText>
        {`${TRANSLATION_TEXT.if_you_have_any_question_feel_free_to} `}
        <StyledLink to={'https://www.rapnet.com/contact/support/'} external newTab>
          {TRANSLATION_TEXT.contact_us_lower}.
        </StyledLink>
      </SecondText>
      <SecondText>{TRANSLATION_TEXT.we_looking_forward_to_assisting_you}</SecondText>
    </Container>
  );
};
export default AcountExistsInCompanyErrorModal;
